/* eslint-disable */
import Navigation from "./Navigation";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import "./Header.css";
import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

//Redux-imports
import { useDispatch, useSelector } from "react-redux";

const Header = (props) => {

  const dispatch = useDispatch();
  const authToken = props.authToken;

  return (
    <div className="header-div">
      <Navigation
        authToken={authToken}
        pageType={props.pageType}
      />
    </div>
  );
};

export default Header;
